module.exports = __webpack_public_path__ + "media/images/ohap_notification-fa97cc4b1cd2d1994d0c3288db4261cc.png";